import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useSnackbar } from "react-simple-snackbar";
import Loader from "react-loader-spinner";
import Swal from "sweetalert2";
import demologo from "../../assets/demologo.png";
import { TimeSpliter } from "../../helpers/planPrice";
import { GetAvalableHost, getRandomTeacherForDemo, CreateSession, getAvailableSlot } from "../../redux/actions/SessionAction";
import { ConfirmDemoPayment } from "../../redux/actions/UserAction";
import { CreateZoomMeeting } from "../../redux/actions/ZoomMeeting";
import { useDispatch } from "react-redux";
import { availableDate, TimeValidator, getAvailableTeacherSate, localToutcTimeConverter, slotFormatAMPM, overlapUTCtimeConverter, formatTimeslot } from "../../helpers/TimeDate";
import razorpayPaymentHelper from "../../helpers/RazorpayPaymentHelper";
import Loder from "../loder";
import { getDevice } from "../../helpers/PageHelper";
import StripePaymentHandler from "../StripePaymentHandler";
import rzpsvg from "../../assets/plans/razorpay-logo.5cdb58df 1.svg";
import stripesvg from "../../assets/plans/Group.svg";

const DemoSchedule = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const isTrialClass = JSON.parse(localStorage.getItem("DEMO_SESSION"));
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const setup = JSON.parse(localStorage.getItem("SETUP"));
  const localstorageSubject = JSON.parse(localStorage.getItem("SUBJECT"));
  const [paymentMethod, setPaymentMethod] = useState("Razorpay");
  const intervaldate = new Date(
    new Date().toLocaleString("en-US", { timeZone: time_zone.timezone })
  );
  //+4
  intervaldate.setHours(intervaldate.getHours() + parseInt(setup ? setup.bookingLag : "2"));

  const [subject, setSubject] = useState(localstorageSubject?localstorageSubject:"English");

  const [loder, setLoder] = useState(false);
  const [getSlotLoder, setGetSlotLoder] = useState(false);
  //DATE
  const [activeDate, setActiveDate] = useState(0);
  const [dateArr, setDateArr] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  //TIME
  const [timeArr, setTimeArr] = useState([]);
  const [selectedTime, setSelectedTime] = useState();

  const [slotsLimit, setSlotLimit] = useState(8);
  const [paymentLoader, setPaymentLoader] = useState(false);


  //HOST
  // const [hostData, setHostData] = useState();
  //TEACHER
  // const [teacherData, setTeacherData] = useState();
  const user = JSON.parse(localStorage.getItem("DEMOUSER"));
  const token = JSON.parse(localStorage.getItem("TOKEN"));


  const blockTimeSlot = (slot) => {

    const splite = slot.split("-");
    var returnValue;
    console.log(intervaldate.getHours())
    if (getAvailableTeacherSate(new Date()) === getAvailableTeacherSate(selectedDate)) {
      if (intervaldate.getHours() > 9 && intervaldate.getHours() < 24) {

        if (intervaldate.getHours() + ":" + intervaldate.getMinutes() >= splite[1].trim()) {
          returnValue = "remove";
        }
      }
    } else {
      if ("10:00" >= splite[0].trim() || "24:00" <= splite[0].trim()) {
        returnValue = "remove";
      }
    }
    return returnValue;
  };


  useEffect(() => {
    var i = 0;
    var dates = []
    for (i; i < 3; i++) {
      dates.push(availableDate(i))
    }
    setSelectedDate(availableDate(0).date);
    setDateArr(dates)

  }, [])

  useEffect(() => {
    setGetSlotLoder(true)
    const onSuccess = (res) => {
      console.log("get slot success")
      console.log(res);
      setGetSlotLoder(false)
      var timeslotsArray = []
      res.data.teacherSlots?.map(val => {
        if (blockTimeSlot(overlapUTCtimeConverter(val.startTime) + " - " + overlapUTCtimeConverter(val.endTime)) !== "remove") {
          timeslotsArray.push(val)
        }
      })
      setTimeArr(timeslotsArray)
    }
    const onError = (res) => {
      setGetSlotLoder(false)
      console.log("get slot error block")
      // openSnackbar("blockhost error")
      console.log(res)
    }
    dispatch(
      getAvailableSlot(
        {
          duration: subject === "English"?15:25,
          sessionType: "Demo",
          sessionDate: getAvailableTeacherSate(selectedDate),
          subject:subject
        },

        onSuccess,
        onError
      )
    )
  }, [selectedDate,subject])


  //PAYMENT
  const SubscribeClapingo = (e) => {
    e.preventDefault();

    const userCurrency = time_zone.country === "IN" ? "INR" : "USD";
    const demoAmount = time_zone.country === "IN" ? 99 : 199;

    const data = {
      amount: demoAmount,
      payment_capture: 1,
      currency: userCurrency,
      notes: {
        Name: user.name,
        Number: user.phoneNumber,
        Email: user.email,
        paymentDetails: "Demo from web ",
      },
      txndesc: "Demo payment",
    };


    const onSuccess = (rzpRes) => {
      console.log("Payment handler on success block")
      setPaymentLoader(true)

      //confirm demo payment API call
      var demopayedData = {
        transactionId: rzpRes.razorpay_order_id,
        learnerId: user._id
      }
      var demoPayed = (res) => {
        // setDemoLoder(false);
        console.log("demo payed success");
        console.log(res);
        localStorage.setItem("DEMO_SESSION", true);

      }
      var demoFailed = (errmsg) => {
        // setDemoLoder(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errmsg,
        });
      }
      dispatch(ConfirmDemoPayment(demopayedData, demoPayed, demoFailed, token))


      //Get Random Teacher API call
      const getRandomTeacherSuccess = (res) => {
        setPaymentLoader(false)
        console.log("get available random teacher successfully called")
        // setTeacherData(res.teacher);
        const teacherData = res.teacher;
        const blockHostSuccess = (res, res2) => {
          setPaymentLoader(true)
          console.log("blockhost on success block");
          const hostData = res;
          const hostId = res2;

          //create meeting
          // get available host & call createMeeting


          const maindata = {
            userId: hostData, //hostdata is email from block host api call
            data: {
              topic: "Clapingo Demo Session",
              type: 2,
              start_time: selectedTime.startTime,
              duration: subject === "English"?15:25,
              schedule_for: hostData,
              timezone: "UTC",
              password: "clapingo",
              agenda: "Learn English",
              settings: {
                host_video: true,
                participant_video: true,
                cn_meeting: false,
                in_meeting: true,
                join_before_host: true,
                mute_upon_entry: true,
                watermark: false,
                use_pmi: false,
                approval_type: 2,
                auto_recording: "cloud",
                registrants_email_notification: true,
              },
            },
          };

          const onSuccess = (data) => {
            setPaymentLoader(true)
            console.log("create zoom meeting onsuccess called")
            if (teacherData) {
              if (data) {
                var meetingndata = {
                  meetingNo: String(data.id),
                  learner: user._id, //learnerid from localstorage
                  teacher_: teacherData.teacher, //teacherid
                  startTime: selectedTime.startTime,
                  endTime: selectedTime.endTime,
                  sessionDate: getAvailableTeacherSate(selectedDate?.toUTCString()),
                  meetingPassword: data.password,
                  startMeetingUrl: data.start_url,
                  joinMeetingUrl: data.join_url,
                  host: data.host_email,
                  isAdmin: false,
                  isWebsite: true,
                  blockHostId: hostId,//blockhost api call id
                  timezone: time_zone.timezone,
                  isTimeUtc: true,
                  subject:subject,
                  source: getDevice()
                };

                meetingndata["type"] = "Demo";
                if(subject === "English"){
                   meetingndata["sessionDuration"] = "15min";
                }else{
                  meetingndata["sessionDuration"] = "25min";
                }
               


                const onSuccess = () => {
                  setPaymentLoader(false)
                  console.log("create clapingo meeting onsuccess called");
                  setLoder(false);

                  if (
                    (user.isTrialBooked === false &&
                      user.isDemoPayed === true) ||
                    isTrialClass
                  ) {
                    localStorage.setItem("DEMO_BOOKED", JSON.stringify(true));
                    localStorage.setItem("DEMO_TIME", JSON.stringify(selectedTime));
                    // localStorage.setItem("DEMO_DATE", JSON.stringify(selectedDate));
                    localStorage.setItem("DEMO_DATE", JSON.stringify(getAvailableTeacherSate(selectedDate)));
                    localStorage.removeItem("DEMO_SESSION");

                    setLoder(false);
                    history.replace({ pathname: 'success' });
                    Swal.fire("Demo Booked Successfully!", "", "success");
                    if(subject === "IELTS"){
                      localStorage.setItem("SUBJECT", JSON.stringify("IELTS"));
                    }
                  } else {
                    Swal.fire("Session Booked Successfully!", "", "success");
                    localStorage.setItem("DEMO_TIME", JSON.stringify(selectedTime));
                    // localStorage.setItem("DEMO_DATE", JSON.stringify(selectedDate));
                    localStorage.setItem("DEMO_DATE", JSON.stringify(getAvailableTeacherSate(selectedDate)));
                    history.replace({ pathname: 'success' });
                    if(subject === "IELTS"){
                      localStorage.setItem("SUBJECT", JSON.stringify("IELTS"));
                    }
                  }
                };
                const onError = (err) => {
                  openSnackbar("create meeting error")
                  console.log(err)
                  setLoder(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: err,
                  });
                };
                dispatch(CreateSession(meetingndata, onSuccess, onError, token));
              } else {
                setLoder(false);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Unable to book meeting due to some technical reason please try again later",
                });
              }
            }
            else {
              setLoder(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Teacher data not available",
              });
            }
          };
          const onError = () => {
            setLoder(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Oops something went wrong !!",
            });
          };
          dispatch(CreateZoomMeeting(maindata, onSuccess, onError));
        }
        const blockHostError = (res) => {
          console.log("blockhost error block")
          openSnackbar("blockhost error")
          console.log(res)
        }
        dispatch(
          GetAvalableHost(
            {
              startTime: selectedTime.startTime,
              endTime: selectedTime.endTime,
              sessionDate: getAvailableTeacherSate(selectedDate),
              isTimeUtc: true,
            },

            blockHostSuccess,
            blockHostError,
            token
          )
        );
      }
      const getRandomTeacherError = (res) => {
        console.log("get available teacher error block");
        openSnackbar("Book teacher error/Teacher not available at that time")
        console.log(res)
      }

      dispatch(
        getRandomTeacherForDemo(
          {
            sessionTime: selectedTime.startTime,
            sessionEndTime: selectedTime.endTime,
            sessionDate: getAvailableTeacherSate(selectedDate),
            subject:subject
          },
          getRandomTeacherSuccess,
          getRandomTeacherError,
          token
        )
      );

    };


    razorpayPaymentHelper(data, onSuccess);
  };

  //  StripeData
  const userData = time_zone.timezone;
  const val = userData.split("/");
  var stripeData = {
    amount: time_zone.country === "IN" ? 99 : 1.99,
     txndesc: "demo",
    currency: time_zone.country === "IN" ? "INR" : "USD",
    source: getDevice(),
    address: {
      line1: "default",
      postal_code: "default",
      city: "default",
      state: "default",
      country: time_zone.country
    },
    notes: {
     
      desc: "demo payment",
      device: getDevice(),
      learnerID: user?._id,
      learner: user?._id,
      
      amount: time_zone.country === "IN" ? 99 : 99 / 100,
      zone1: val[0],
      zone2: val.length > 1 ? val[1] : undefined,
      isNewSchema: "true"
    }
  }
  // var stripeData={
  //   key:"value"
  // }

  return (
    <div>
      { }
      {paymentLoader ?
        <div>
          <h6 className="text-center">Payment Processing</h6>
          <div className="text-center">
            <Loader type="Grid" color="#00BFFF" height={80} width={80} />
          </div>
        </div> :
        <form >
          <div className="demo-form">
            <div className=" mt-3">
              <label>
                <div className="mb-2">
                  <img
                    width="122px"
                    height="32px"
                    src={demologo}
                    alt="clapingologo"
                  />
                </div>
                <p className="headingfont">Date and Time</p>
                <p className="subtitle">Select date and time of trial</p>
              </label>


              <p className="subtitleA mt-2">Select a subject</p>
           <div className="d-flex">

             <div className="form-check">
                <input className="form-check-input" type="radio" name="English" id="englishRadio" checked={subject === "English"} onChange={()=>setSubject("English")}/>
                <label className="form-check-label" htmlFor="englishRadio">
                Spoken English
                </label>
              </div>

              <div className="form-check ml-5">

                <input className="form-check-input" type="radio" name="IELTS" id="ieltsRadio" checked={subject === "IELTS"} onChange={()=>setSubject("IELTS")}/>
                <label className="form-check-label" htmlFor="ieltsRadio">
                IELTS
                </label>
              </div>
           </div>


            {/* <div>
              <p className="subtitleA mt-2">Select a subject</p>
              <button type="button" className={`timeBTN m-1 ${subject === "English"?"active-time":""}`} onClick={()=>setSubject("English")}>Spoken English</button>
              <button type="button" className={`timeBTN m-1 ${subject === "IELTS"?"active-time":""}`} onClick={()=>setSubject("IELTS")}>IELTS</button>
            </div> */}


              <div>
                <p className="subtitleA mt-2">Select a date</p>
                <div>
                  {dateArr.map((data, i) => (
                    <button
                      type="button"
                      onClick={() => {
                        setActiveDate(i)
                        setSelectedDate(data.date)
                        setSlotLimit(8)
                        setSelectedTime("")
                      }}
                      className={`dateBTN  mr-md-3 mr-2 ${i === activeDate ? "active-date" : ""}`}
                      key={i}
                    >
                      <span style={{ color: "#139980" }}>{data.dateNo} {data.weekDay}</span>
                      <br />
                      {data.month}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <p className="subtitleA mt-4">Select a Time slot</p>
                {
                  getSlotLoder ? <Loder /> :
                    <div className="d-flex flex-wrap">

                      {
                        timeArr.slice(0, slotsLimit).map((val, i) => {
                          return <button type="button" className={`timeBTN m-1 ${selectedTime?.startTime === val.startTime ? "active-time" : ""}`} onClick={() => setSelectedTime(val)} key={i}>{slotFormatAMPM(`${overlapUTCtimeConverter(val.startTime)} - ${overlapUTCtimeConverter(val.endTime)}`)}</button>
                        })
                      }
                      {
                        slotsLimit !== timeArr.length ?
                          <button className="timeBTN  m-1" type="button" onClick={() => setSlotLimit(slotsLimit + 8)}>View more</button>
                          : ""
                      }

                    </div>
                }

              </div>
              <div className="d-md-flex make-payment justify-content-around mt-3">
                <div
                  className={`payment-selector ${paymentMethod === "Razorpay" ? `active` : ""
                    }`}
                >
                  <input
                    type="radio"
                    id="razorpay"
                    value="Razorpay"
                    name="radio-group"
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    checked={paymentMethod === "Razorpay"}
                  />
                  <label htmlFor="razorpay">
                    <img src={rzpsvg} className="mt-2" alt="razorpay" />
                  </label>
                </div>
                <div
                  className={`payment-selector ${paymentMethod === "Stripe" ? `active` : ""
                    }`}
                >
                  <input
                    type="radio"
                    id="stripe"
                    value="Stripe"
                    name="radio-group"
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    checked={paymentMethod === "Stripe"}
                  />
                  <label htmlFor="stripe">
                    <img src={stripesvg} className="mt-2" alt="stripe" />
                  </label>
                </div>
              </div>
              {paymentMethod=== "Razorpay" ?
              <button
              // onClick={() => history.replace({ pathname: "success" })}
              onClick={(e)=>SubscribeClapingo(e)}
              // type="submit"
              disabled={loder || !selectedTime ? true : false}
              className={
                loder
                  ? "continueBTNdisabled btn-block mx-auto"
                  : "continueBTN  btn-block mx-auto"
              }
            >
              {loder ? "Loading ..." : "Make Payment"}
            </button>
            :
            selectedTime ? <StripePaymentHandler demoData={stripeData} selectedTime={selectedTime} selectedDate={selectedDate} />
            : <p className="text-center text-danger">Please select a time slot</p>
            }
              

            </div>
          </div>
        </form>

      }
      
    </div>
  );
};

export default DemoSchedule;